<template>
  <div id="settings-engineers-audit-log">
    <div class="clearfix">
      <div class="float-left audit-log-header">
        {{ $t('settings.auditLogExport.title') }}
      </div>
      <div
        v-if="hasPermission()"
        class="float-right"
      >
        <button
          type="button"
          class="btn btn--orange"
          :disabled="!startDate"
          @click="exportData()"
        >{{ $t('action.export') }}</button>
      </div>
      <hr>
    </div>
    <div
      v-if="hasPermission()"
      class="row clearfix"
    >
      <DatePicker
        id="audit-log-start-date"
        v-model="startDate"
        format="DD MMM YY"
        :calendarButton="true"
        :placeholder="$t('settings.auditLogExport.startFrom')"
        :disabled="startDisabledDatesUntil"
        calendarButtonIcon="fa fa-calendar"
      />
      <DatePicker
        id="audit-log-end-date"
        v-model="endDate"
        format="DD MMM YY"
        :calendarButton="true"
        :placeholder="$t('settings.auditLogExport.until')"
        :disabled="endDisabledDatesUntil"
        calendarButtonIcon="fa fa-calendar"
      />
    </div>
  </div>
</template>

<script>
import DatePicker from '@/controls/DatePicker'
import { aclHelper } from '@/utils/aclHelper'
import { exportAuditLog } from '@/api/events/request'
import moment from 'moment'

export default {
  name: 'AuditLog',
  components: {
    DatePicker,
  },
  data () {
    const now = new Date()
    return {
      MAX_EXPORT_MONTHS: 1,
      startDate: null,
      endDate: null,
      now,
    }
  },
  computed: {
    endDisabledDatesUntil () {
      if (!this.startDate) return { from: this.now }

      const enabledPeriodEnd = moment(this.startDate).add(this.MAX_EXPORT_MONTHS, 'months')
      const disableFrom = new Date(enabledPeriodEnd)
      const from = new Date(Math.min(disableFrom, this.now))
      const to = this.startDate

      return { from, to }
    },
    startDisabledDatesUntil () {
      if (!this.endDate) return { from: this.now }

      const enabledPeriodStart = moment(this.endDate).subtract(this.MAX_EXPORT_MONTHS, 'months')
      const to = new Date(enabledPeriodStart)
      const from = new Date(Math.min(this.endDate, this.now))

      return { from, to }
    },
  },
  methods: {
    hasPermission () {
      return aclHelper.getSettingsUpdateAccess() || aclHelper.hasSettingsReadAccess()
    },
    async exportData () {
      if (!this.endDate) this.endDate = this.endDisabledDatesUntil.from

      let untilDateTime = this.endDate
      if (untilDateTime) {
        // by default, the date include time 00:00:00, which means the endDate is excluded for the exporting
        untilDateTime = moment(untilDateTime).add(1, 'days').valueOf()
      }
      await exportAuditLog(this.startDate.getTime(), untilDateTime)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/settings/style';
#settings-engineers-audit-log {
  padding: 0 24px 15px 24px;
}
.audit-log-header {
  font-size: 16px;
  font-weight: bold;
  margin: 0.85em 0;
}
.row .vdp-datepicker {
  margin-right: 15px;
}
</style>
